"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FallbackEventEmitter", {
    enumerable: true,
    get: function() {
        return FallbackEventEmitter;
    }
});
const _emittery = /*#__PURE__*/ _interop_require_default(require("emittery"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let FallbackEventEmitter = class FallbackEventEmitter {
    emit(event, data) {
        this.emitter.emit(event, data);
    }
    on(event, listener) {
        this.emitter.on(event, listener);
        return ()=>this.emitter.off(event, listener);
    }
    removeListener(event, listener) {
        this.emitter.off(event, listener);
    }
    removeAllListeners(event) {
        this.emitter.clearListeners(event);
    }
    constructor(){
        this.emitter = new _emittery.default();
    }
};
